import { Card, SectionLabel } from '@wundo/ui';
import type { RoleplayScenario } from '@wundo/shared/roleplay.ts';
import { PracticeObjectiveList } from './PracticeObjectiveList.tsx';
import { m } from '@/paraglide/messages.js';

export interface PracticeSessionBriefProps {
  scenario: RoleplayScenario;
}

/**
 * What the conversation is about and what you are practising, beside it the
 * whole time.
 *
 * Kept on screen rather than shown once before the start: the objectives are
 * what the feedback is written against, and somebody two minutes into a
 * difficult conversation should not have to remember them.
 */
export function PracticeSessionBrief({ scenario }: PracticeSessionBriefProps) {
  return (
    <div className='flex flex-col gap-3.5'>
      <Card as='section'>
        <SectionLabel as='h2'>{m.practice_situation()}</SectionLabel>
        <p className='mt-3 text-md text-ink-body'>{scenario.situation}</p>
      </Card>

      <Card as='section'>
        <SectionLabel as='h2'>{m.practice_objectives()}</SectionLabel>
        <PracticeObjectiveList
          objectives={scenario.learning_objectives}
          className='mt-3'
        />
      </Card>
    </div>
  );
}
